export const ProfileSettingRoute = {
  ProfileEdit: 'profile-edit',
  Chats: 'chats',
  MyPosts: 'my-posts',
  Participated: 'participated',
  Help: 'help',
  AppSetting: 'app-setting',
  NotificationSetting: 'notification-setting',
  OrganizationOverview: 'organization-overview',
  OrganizationDetail: 'organization-detail',
  OrganizationActivities: 'organization-activities',
  OrganizationManagement: 'organization-management',
  OrganizationMembers: 'organization-members',
  OrganizationPosts: 'organization-posts',
  OrganizationPostsWithActivities: 'organization-posts-with-activities',
  OrganizationEdit: 'organization-edit',
  OrganizationsInArea: 'organizations-in-area',
  StatisticsEmail: 'statistics-email'
} as const;

export type ProfileSettingRoute =
  (typeof ProfileSettingRoute)[keyof typeof ProfileSettingRoute];

export type ProfileSettingParam = {
  [ProfileSettingRoute.ProfileEdit]: undefined;
  [ProfileSettingRoute.Chats]: undefined;
  [ProfileSettingRoute.MyPosts]: undefined;
  [ProfileSettingRoute.Participated]: undefined;
  [ProfileSettingRoute.Help]: undefined;
  [ProfileSettingRoute.AppSetting]: undefined;
  [ProfileSettingRoute.NotificationSetting]: undefined;
  [ProfileSettingRoute.OrganizationOverview]:
    { geoAreaId?: string } | undefined;
  [ProfileSettingRoute.OrganizationDetail]: { id: string };
  [ProfileSettingRoute.OrganizationActivities]: { organizationId: string };
  [ProfileSettingRoute.OrganizationManagement]: { organizationId: string };
  [ProfileSettingRoute.OrganizationMembers]: { organizationId: string };
  [ProfileSettingRoute.OrganizationPosts]: { organizationId: string };
  [ProfileSettingRoute.OrganizationPostsWithActivities]: {
    organizationId: string;
  };
  [ProfileSettingRoute.OrganizationEdit]: { organizationId: string };
  [ProfileSettingRoute.OrganizationsInArea]: {
    organizationId: string;
    geoAreaId?: string;
  };
  [ProfileSettingRoute.StatisticsEmail]: { organizationId: string };
};
